import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faEye,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import {
  Card,
  Table,
  ButtonGroup,
  Button,
  InputGroup,
  Form,
} from "@themesberg/react-bootstrap";

import { GetAllKodepayVA, reset } from "../../../features/kodepayVASlice";
import AdminLayout from "../../../layout/admin";
import { Header, PaginationComponent } from "../../../components/admin";
import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";
import { faClone } from "@fortawesome/free-regular-svg-icons";
import ModalDuplicateKodepay from "./../../../components/modal/ModalDuplicateKodepay/index";

const DataListPeriod = () => {
  const [query, setQuery] = useState("");
  const [sortBy, setSortBy] = useState("created_at");
  const [sortType, setSortType] = useState("DESC");
  const [row, setRow] = useState("10");
  const [page, setPage] = useState("1");

  const [showDuplicateModal, setShowDuplicateModal] = useState(null);

  const { pathname } = useLocation();

  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state) => state.kodepayVA);

  const token = localStorage.getItem("token");

  useEffect(() => {
    dispatch(reset());
    dispatch(
      GetAllKodepayVA({
        token,
        url: `q=${query}&pageNumber=${page}&sortBy=${sortBy}&sortType=${sortType}&pageSize=${row}`,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, token, page, sortBy, sortType, row]);

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(reset());
    dispatch(
      GetAllKodepayVA({
        token,
        url: `q=${query}&pageNumber=${page}&sortBy=${sortBy}&sortType=${sortType}&pageSize=${row}`,
      })
    );
  };

  const handlePagination = (item) => {
    setPage(item);
  };

  const onClickDuplicate = async (period) => {
    showLoadingDialog();
    try {
      let response;
      if (period) {
        response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}master/kode_payment/duplicate`,
          {
            tahun_sumber: showDuplicateModal,
            tahun_mulai: period,
          },
          {
            headers: {
              Authorization: token,
            },
          }
        );
        console.log("RESPONSE : ", response);
        hideLoadingDialog();
        showSuccessDialog({
          title: "Berhasil!",
          msg: "Berhasil menduplikasi data!",
        });
        // dismiss the modal
        setShowDuplicateModal(null);
        dispatch(
          GetAllKodepayVA({
            token,
            url: `q=${query}&pageNumber=${page}&sortBy=${sortBy}&sortType=${sortType}&pageSize=${row}`,
          })
        );
      } else {
        // eslint-disable-next-line no-throw-literal
        throw "id not found!";
      }
    } catch (error) {
      console.log("ERROR", error);
      hideLoadingDialog();
      showFailedDialog({
        title: "Oops!",
        msg: error?.response?.data?.message || "Gagal duplikasi data!",
      });
    }
  };

  const onClickDelete = (period) => {
    showAlertDialog({
      title: "Hapus?",
      msg: "Apakah anda yakin ingin menghapus ini?",
      confirmButtonText: "Hapus",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (period) {
            response = await axios.delete(
              `${process.env.REACT_APP_BASE_URL}master/kode_payment/delete_by_period/${period}`,
              {
                headers: {
                  Authorization: token,
                },
              }
            );
            console.log("RESPONSE : ", response);
            hideLoadingDialog();
            showSuccessDialog({
              title: "Berhasil!",
              msg: "Berhasil menghapus data!",
            });
            dispatch(
              GetAllKodepayVA({
                token,
                url: `q=${query}&pageNumber=${page}&sortBy=${sortBy}&sortType=${sortType}&pageSize=${row}`,
              })
            );
          } else {
            // eslint-disable-next-line no-throw-literal
            throw "id not found!";
          }
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menghapus data!",
          });
        }
      },
    });
  };

  return (
    <AdminLayout>
      <Header title="Kode payment">
        <Button
          as={Link}
          variant="outline-primary"
          size="sm"
          to={`/master/${pathname.split("/")[2]}/add`}
        >
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          Tambah
        </Button>
        <ModalDuplicateKodepay
          show={showDuplicateModal}
          onClose={() => setShowDuplicateModal(null)}
          cb={(tahun) => onClickDuplicate(tahun)}
        />
      </Header>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between">
              <form onSubmit={handleSearch}>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </InputGroup>
              </form>
              <div className="d-flex gap-3">
                <Form.Group>
                  <Form.Select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    <option value="created_at">Dibuat</option>
                    <option value="periode_mulai">Periode</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group>
                  <Form.Select
                    value={sortType}
                    onChange={(e) => setSortType(e.target.value)}
                  >
                    <option value="DESC">DESC</option>
                    <option value="ASC">ASC</option>
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <Table
            responsive
            className="table-centered table-nowrap rounded mb-0"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-0">#</th>
                <th className="border-0">Periode</th>
                <th className="border-0 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <th colSpan="3" style={{ textAlign: "center" }}>
                    Loading
                  </th>
                </tr>
              ) : (data?.items || []).length > 0 ? (
                data?.items?.map((item, i) => (
                  <tr key={i}>
                    <th>{(page - 1) * 10 + (i + 1)}</th>
                    <th>{item.periode_mulai}</th>
                    <th className="text-center">
                      <ButtonGroup size="sm">
                        <Button
                          as={Link}
                          to={`/master/${pathname.split("/")[2]}/list/${
                            item.periode_mulai
                          }`}
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </Button>
                        <Button
                          variant="warning"
                          onClick={() => {
                            setShowDuplicateModal(item.periode_mulai);
                          }}
                        >
                          <FontAwesomeIcon icon={faClone} />
                        </Button>
                        <Button
                          variant="danger"
                          onClick={() => onClickDelete(item.periode_mulai)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </ButtonGroup>
                    </th>
                  </tr>
                ))
              ) : (
                <tr>
                  <th colSpan="3" style={{ textAlign: "center" }}>
                    Tidak ada data!
                  </th>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <Form.Group>
                <Form.Select
                  placeholder="Row"
                  value={row}
                  onChange={(e) => setRow(e.target.value)}
                >
                  <option defaultValue="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                </Form.Select>
              </Form.Group>

              <PaginationComponent
                meta={data?.meta}
                handlePagination={(item) => handlePagination(item)}
              />
            </div>
          </div>
        </Card.Footer>
      </Card>
    </AdminLayout>
  );
};

export default DataListPeriod;
